import React from 'react';
import './Testimonials.css';

interface Testimonial {
  quote: string;
  author: string;
  role: string;
  country: string;
}

const testimonials: Testimonial[] = [
  {
    quote:
      'Daksh Ravitaj has been a reliable supplier of Ashwagandha and Shatavari for our wellness line. Consistent quality, proper documentation, and responsive communication make them our go-to partner.',
    author: 'M. Hoffmann',
    role: 'Procurement Manager',
    country: 'Germany',
  },
  {
    quote:
      'We have been sourcing Amla and Safed Musli powder in bulk for over two years. The product meets our quality specifications every time and the export paperwork is always clean.',
    author: 'R. Al-Farsi',
    role: 'Import Director',
    country: 'UAE',
  },
  {
    quote:
      'Outstanding service and product purity. Their GMP certification and COA documentation gave us confidence to list their herbs under our own brand in the UK market.',
    author: 'S. Patel',
    role: 'Founder',
    country: 'United Kingdom',
  },
];

const Testimonials: React.FC = () => {
  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-container">
        <h2>What Our Partners Say</h2>
        <p className="testimonials-sub">
          Trusted by distributors and wellness brands across the globe.
        </p>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div className="testimonial-card" key={i}>
              <div className="testimonial-quote-icon">"</div>
              <p className="testimonial-text">{t.quote}</p>
              <div className="testimonial-author">
                <span className="author-name">{t.author}</span>
                <span className="author-meta">
                  {t.role} &mdash; {t.country}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
